var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"c-btnSquare",class:{'isEnter': _vm.isEnter, 'isWhite': _vm.bgColor === 'white'},attrs:{"href":_vm.url},on:{"mouseenter":_vm.onHover,"mouseleave":_vm.onHover}},[_c('span',{staticClass:"c-btnSquare__text",class:{'f-ITC-BoldIt': _vm.isEn}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }